import { render } from "./PurchaseCreditsView.vue?vue&type=template&id=f5ab87c2"
import script from "./PurchaseCreditsView.vue?vue&type=script&lang=js"
export * from "./PurchaseCreditsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__